import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Publisher, PublisherRequest } from '@/module/Publisher';

import { Id, PagedParams, PagedResponse, getQueryKey } from '@feature/utils';

import * as api from './PublisherApi';

const publisherKey = getQueryKey('publisher');

export function getPublisherPagedOptions(params: PagedParams): UseSuspenseQueryOptions<PagedResponse<Publisher>> {
  return {
    queryKey: publisherKey.paged(params),
    queryFn: () => api.getPaged(params),
  };
}

export function getPublisherOptions(publisherId: Id): UseSuspenseQueryOptions<Publisher> {
  return {
    queryKey: publisherKey.one(publisherId),
    queryFn: () => api.get(publisherId),
  };
}

export function getPublisherFindByTitleOptions(title: string): UseSuspenseQueryOptions<Publisher> {
  return {
    queryKey: publisherKey.as(['find-by', title]),
    queryFn: () => api.findByTitle(title),
  };
}

export function usePublisherEdit(publisherId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: PublisherRequest) => api.edit(publisherId, request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: publisherKey.root(),
      }),
  });
}

export function usePublisherCreate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: PublisherRequest) => api.create(request),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: publisherKey.root(),
      }),
  });
}

export function usePublisherDelete(publisherId: Id) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.deleteById(publisherId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: publisherKey.root(),
      }),
  });
}
